export class MsalCredentials {
   email: string;
   token: string;
   name: string;
   surname: string;
   displayName: string;
}
